<template lang="html">
    <div class="article">
        <div class="banner-img">
        </div>
        <div class="container">
            <p>全医佳新闻资讯列表 / <span>内容详情</span></p>
            <div class="content">
                <h2>踏青赏春光，不负芳菲四月天</h2>
                <p>生活不止眼前的苟且，还有诗和远方的田野。</p>
                <p>工作不止办公楼与宿舍的两点一线，还有丰富多彩的团建</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/1.jpg" alt="">
                </div>
                <p>疫情即将迎来胜利，</p>
                <p>一直忙碌紧张地保障医院设备运行的全医佳人</p>
                <p>也迎来了2020年的第一次团建活动</p>
                <h3>一、经典型团建</h3>
                <p class="title">1. 春日草莓 甜入心脾</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/2.jpg" alt="">
                </div>
                <p class="title">2.团队合作，齐心协力</p>
                <p>多项团队合作分组竞赛，</p>
                <p>充分展现了全医佳人的团队精神和积极进取的信心。</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/3.jpg" alt="">
                </div>
                <h3>二、坦克大战 斗智斗勇</h3>
                <p>团队合作竞技游戏，</p>
                <p>各队伍密切合作，手疾眼快，</p>
                <p>发起了猛烈的进攻，呐喊声、指挥声燃爆全场！</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/4.jpg" alt="">
                </div>
                <h3>三、表彰优秀 鼓励奋斗</h3>
                <p>全医佳聚集了一群愿意吃苦、愿意努力奋斗的人，</p>
                <p>是因为全医佳人是一群有使命、有理想的人。</p>
                <p>有理想的全医佳人，</p>
                <p>让我们一起共同去建立、健全、优化和完善现代化的企业管理机制，</p>
                <p>并坚决的履行在行动中，</p>
                <p>一起在苦难中奋斗、在风雨中拼搏！</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/5.jpg" alt="">
                </div>
                <h3>四、自力更生 丰衣足食</h3>
                <p>工作中的先锋突击手，</p>
                <p>生活中的烧烤小能手，</p>
                <p>全方位展示了全医佳人的多才多艺!</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/6.jpg" alt="">
                </div>
                <h3>五、篝火熊熊  笑语阵阵</h3>
                <p>温暖的篝火旁，一张张笑脸、一阵阵歌声、还有那舞动的身影，</p>
                <p>构成了一幅幸福和谐的画面。</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/8.jpg" alt="">
                </div>
                <p class="text-center">我们一起奔跑在春天里，</p>
                <p class="text-center">用欢声笑语驱散往日的紧张情绪，</p>
                <p class="text-center">通过这次的团建活动，</p>
                <p class="text-center">不仅让大家工作压力得到释放，</p>
                <p class="text-center">也促进了团队之间的默契和协作，</p>
                <p class="text-center">增强了团队的凝聚力和向心力。</p>
                <p class="text-center">全医佳大家庭也将以更加团结的面貌，</p>
                <p class="text-center">更加努力的工作，争创2020年佳绩！</p>
                <div>
                    <img src="http://qyjmed-static.oss-cn-hangzhou.aliyuncs.com/webSite/news/group/7.jpg" alt="">
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
	name: 'article1',
	components: {
		Foot
	}
}
</script>

<style lang="scss" scoped>
.article {
    letter-spacing: 1px;
    background: #F6F8FA;
    color: #000;
    .banner-img {
        margin-top: $highlight-height;
        height: 140px;
        background: url("https://static.qyjmed.com/webSite/productService/document/bg.png") center;
    }
    .container {
        > p {
            font-size: 18px;
            line-height: 76px;
            span {
                color: #4EAAFC;
            }
        }
        .content {
            min-height: 600px;
            background: white;
            padding: 0 70px 70px;
            margin-bottom: 30px;
            h2 {
                font-size: 22px;
                text-align: center;
                font-weight: 400;
                padding: 46px 0 20px;
            }
            p {
                line-height: 40px;
                text-indent: 2rem;
                text-align: center;
            }
            p.title {
                font-weight: bold;
            }
            p.text-center {
                text-align: center;
            }
            h3 {
                color: #4CAF50;
                text-align: center;
                margin-top: 40px;
            }
            div {
                text-align: center;
                img {
                    width: 900px;
                    padding: 10px 0;
                }
            }
        }
    }
}
</style>
